export function timerSetup() {
  let startTime = new Date().getTime();

  return {
    finish: () => {
      const timeDiff = new Date().getTime() - startTime;
      startTime = new Date().getTime();
      return timeDiff;
    },
  };
}
